import { useTransition } from '../hooks/useTransition';
import './PageLayout.css';

export default function PageLayout({ title, children }) {
  const { navigateWithTransition } = useTransition();

  return (
    <div className="page-layout">
      <button className="page-back" onClick={() => navigateWithTransition('/')}>
        &larr; Back
      </button>
      <h1 className="page-title">{title}</h1>
      <div className="page-content">{children}</div>
    </div>
  );
}
